import { SimpleGrid, Container } from "@chakra-ui/react";
import React from "react";
import Banner from "../components/marketplaceCategory/Banner";
import FreelancerCard from "../components/marketplaceCategory/FreelancerCard";
import CommonContainer from "../components/shared/CommonContainer";

export default function MarketplaceCategoryPage() {
  return (
    <>
      <Container px={{ sm: 10 }} maxW={{ sm: "90vw" }}>
        <Banner />
      </Container>
      <CommonContainer>
        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3, xl: 4 }}
          gap={{ base: 8, xl: 16 }}
          pb={40}
          pt={10}
        >
          {categoryData.map((item, index) => {
            return (
              <FreelancerCard
                key={index}
                title={item.title}
                description={item.description}
                coverImageUrl={item.coverImageUrl}
                profileImageUrl={item.profileImageUrl}
                verified={item.verified}
                online={item.online}
                price={item.price}
                pro={item.pro}
              />
            );
          })}
        </SimpleGrid>
      </CommonContainer>
    </>
  );
}

const categoryData = [
  {
    title: "Logo Master",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-1.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-1.png",
    verified: true,
    online: true,
    price: 20,
    pro: true,
  },
  {
    title: "Suzan Albert",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-2.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-2.png",
    verified: false,
    online: false,
    price: 10,
  },
  {
    title: "Tim John",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-3.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-3.png",
    verified: true,
    online: false,
    price: 20,
  },
  {
    title: "Josh Gibbons",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-4.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-4.png",
    verified: false,
    online: true,
    price: 20,
  },
  {
    title: "Logo Master",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-1.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-1.png",
    verified: true,
    online: true,
    price: 20,
  },
  {
    title: "Suzan Albert",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-2.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-2.png",
    verified: false,
    online: false,
    price: 10,
  },
  {
    title: "Tim John",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-3.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-3.png",
    verified: true,
    online: false,
    price: 20,
  },
  {
    title: "Josh Gibbons",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-4.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-4.png",
    verified: false,
    online: true,
    price: 20,
  },
  {
    title: "Logo Master",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-1.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-1.png",
    verified: true,
    online: true,
    price: 20,
  },
  {
    title: "Suzan Albert",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-2.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-2.png",
    verified: false,
    online: false,
    price: 10,
  },
  {
    title: "Tim John",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-3.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-3.png",
    verified: true,
    online: false,
    price: 20,
  },
  {
    title: "Josh Gibbons",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-4.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-4.png",
    verified: false,
    online: true,
    price: 20,
  },
  {
    title: "Logo Master",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-1.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-1.png",
    verified: true,
    online: true,
    price: 20,
  },
  {
    title: "Suzan Albert",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-2.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-2.png",
    verified: false,
    online: false,
    price: 10,
  },
  {
    title: "Tim John",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-3.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-3.png",
    verified: true,
    online: false,
    price: 20,
  },
  {
    title: "Josh Gibbons",
    description: "I will design 3 modern minimalist logo design",
    coverImageUrl: "/images/marketplace-category/logo/logo-4.png",
    profileImageUrl: "/images/marketplace-category/profile/profile-4.png",
    verified: false,
    online: true,
    price: 20,
  },
];
